import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  tag: FelaCSS;
  tagsWrap: FelaCSS;
  topics: FelaCSS;
  adWrapper: FelaCSS;
  planWrapper: FelaCSS;
}

const styles = (): IStyles => ({
  tagsWrap: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: 10,

    maxWidthTabletSm: { justifyContent: 'flex-start' },
  },
  tag: {
    color: colors.space,
    textTransform: 'capitalize',
    fontDefault: 14,
    marginRight: '5px',
    backgroundColor: colors.indigoCrush04,
    borderRadius: '100px',
    paddingVertical: 1,
    paddingHorizontal: 2,
  },
  topics: {
    fontDefaultSemiBold: 18,
    paddingBottom: 6,
  },
  adWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 2,
  },
  planWrapper: {
    width: '100%',
    alignItems: 'center',
    marginTop: 8,
  },
});

export default styles;
